/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import React, { DetailedHTMLProps, HTMLAttributes } from "react";
import { AiOutlinePlus } from "react-icons/ai";

interface ButtonWrapperProps {
  isActiveButtonWrapper: boolean;
  isAtived?: boolean;
}

const ButtonWrapper = styled(motion.div)<ButtonWrapperProps>`
  min-width: 32px;
  min-height: 32px;

  background: ${(props) =>
    props.isActiveButtonWrapper
      ? "#fb972e"
      : props.isAtived
      ? "transparent"
      : "#bbbbbb"};

  border-radius: 50%;

  border: 1px solid
    ${(props) => (props.isActiveButtonWrapper ? "#fb972e" : "#bbbbbb")};

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;

  cursor: pointer;

  transition: all 0.3s;

  > svg {
    width: 20px;
    height: 20px;
    fill: ${(props) =>
      props.isActiveButtonWrapper || !props.isAtived ? "#ffffff" : "#707070"};
  }

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }

  &::before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 48px;
    height: 48px;
    margin-top: -24px;
    margin-left: -24px;
    border-radius: 50%;

    ${(props) =>
      props.isAtived
        ? `border: 1px dashed #fb972e;
       animation: spinner 0.6s linear infinite;`
        : `
      border: 1px dashed #bbbbbb;
      `}
  }

  &:hover {
    border: 1px solid #fb972e;
    background: #fb972e;

    > svg {
      fill: #ffffff;
    }

    &::before {
      border: 1px dashed #fb972e;
    }
  }
`;

interface PlusButtonProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  isActiveButtonWrapper: boolean;
  isAtived?: boolean;
}

export default function PlusButton(props: any) {
  return (
    <ButtonWrapper
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      {...props}
    >
      <AiOutlinePlus />
    </ButtonWrapper>
  );
}
